<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300">
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in zoom-in-95 duration-300">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50">
      <div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Documentos de Partner</h3>
        <p class="text-xs text-gray-500 mt-0.5">{{ partner.company_name }}</p>
      </div>
      <button (click)="close.emit()" class="p-2 hover:bg-white dark:hover:bg-gray-700 rounded-xl transition-all text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      <!-- Upload Zone -->
      <div class="mb-6">
        <label class="relative group cursor-pointer block">
          <input type="file" class="hidden" (change)="onFileSelected($event)" [disabled]="isUploading">
          <div class="border-2 border-dashed border-gray-200 dark:border-gray-700 group-hover:border-brand-red rounded-xl p-8 transition-all text-center bg-gray-50/50 dark:bg-gray-800/30">
            @if (isUploading) {
              <div class="inline-block w-8 h-8 border-2 border-brand-red border-t-transparent rounded-full animate-spin mb-2"></div>
              <p class="text-sm font-medium text-gray-900 dark:text-white">Subiendo archivo...</p>
            } @else {
              <fa-icon [icon]="faUpload" class="text-2xl text-gray-300 group-hover:text-brand-red mb-2 transition-colors"></fa-icon>
              <p class="text-sm font-medium text-gray-900 dark:text-white">Haga clic para subir un documento</p>
              <p class="text-xs text-gray-500 mt-1">Máximo 10MB</p>
            }
          </div>
        </label>
      </div>

      <!-- Files List -->
      <div class="space-y-3 max-h-[300px] overflow-y-auto pr-1">
        @if (isLoading) {
          <div class="flex flex-col items-center py-10 opacity-50">
            <div class="w-6 h-6 border-2 border-brand-red border-t-transparent rounded-full animate-spin mb-2"></div>
            <span class="text-xs">Cargando documentos...</span>
          </div>
        } @else if (files.length === 0) {
          <div class="text-center py-10 bg-gray-50/50 dark:bg-gray-800/30 rounded-xl border border-gray-100 dark:border-gray-800">
            <fa-icon [icon]="faFile" class="text-3xl text-gray-200 dark:text-gray-700 mb-2"></fa-icon>
            <p class="text-xs text-gray-500">No hay documentos subidos</p>
          </div>
        } @else {
          @for (file of files; track file.id) {
            <div class="flex items-center gap-3 p-3 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl hover:border-brand-red/30 transition-all group">
              <div class="w-10 h-10 rounded-lg bg-gray-50 dark:bg-gray-700 flex items-center justify-center text-gray-400 group-hover:text-brand-red transition-colors">
                <fa-icon [icon]="faFile"></fa-icon>
              </div>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-semibold text-gray-900 dark:text-white truncate" [title]="file.name">{{ file.name }}</p>
                <div class="flex items-center gap-2 mt-0.5">
                  <span class="text-[10px] text-gray-500">{{ formatBytes(file.size) }}</span>
                  <span class="text-[10px] text-gray-300">•</span>
                  <span class="text-[10px] text-gray-500">{{ file.created_at | date:'dd/MM/yyyy' }}</span>
                </div>
              </div>
              <div class="flex items-center gap-1">
                <button (click)="downloadFile(file)" class="p-2 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg transition-all" title="Descargar">
                  <fa-icon [icon]="faDownload"></fa-icon>
                </button>
                <button (click)="deleteFile(file.id)" class="p-2 text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg transition-all" title="Eliminar">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </button>
              </div>
            </div>
          }
        }
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50/50 dark:bg-gray-800/50 border-t border-gray-100 dark:border-gray-800 flex justify-end">
      <button (click)="close.emit()" class="px-5 py-2 text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-white dark:hover:bg-gray-700 rounded-xl transition-all">
        Cerrar
      </button>
    </div>
  </div>
</div>
